import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { XCircle, ArrowLeft, MessageCircle } from "lucide-react";

export default function CheckoutCancel() {
    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4 py-12 relative overflow-hidden">
            {/* Background elements */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                <div className="absolute top-20 left-10 w-64 h-64 bg-destructive/10 rounded-full blur-3xl" />
                <div className="absolute bottom-20 right-10 w-96 h-96 bg-muted/10 rounded-full blur-3xl" />
            </div>

            <Card className="max-w-2xl w-full border-border/50 relative z-10">
                <CardHeader className="text-center">
                    <div className="mx-auto mb-4 h-20 w-20 rounded-full bg-destructive/10 flex items-center justify-center">
                        <XCircle className="h-10 w-10 text-destructive" />
                    </div>
                    <CardTitle className="text-3xl">Pagamento Cancelado</CardTitle>
                    <CardDescription className="text-lg mt-4">
                        Não se preocupe, nenhuma cobrança foi realizada
                    </CardDescription>
                </CardHeader>
                <CardContent className="space-y-6">
                    <div className="bg-muted/50 border border-border rounded-lg p-6 text-center">
                        <p className="text-muted-foreground mb-4">
                            Você cancelou o processo de pagamento. Seus dados estão seguros e nenhuma cobrança foi efetuada.
                        </p>
                        <p className="text-sm text-muted-foreground">
                            Se você teve algum problema ou dúvida durante o processo, estamos aqui para ajudar!
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-4">
                        <Card className="border-primary/30">
                            <CardHeader>
                                <CardTitle className="text-lg">Precisa de Ajuda?</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <p className="text-sm text-muted-foreground mb-4">
                                    Nossa equipe está pronta para esclarecer qualquer dúvida sobre os planos ou processo de pagamento.
                                </p>
                                <Button asChild className="w-full">
                                    <Link to="/contato" className="flex items-center gap-2">
                                        <MessageCircle className="h-4 w-4" />
                                        Falar com Suporte
                                    </Link>
                                </Button>
                            </CardContent>
                        </Card>

                        <Card className="border-primary/30">
                            <CardHeader>
                                <CardTitle className="text-lg">Quer Tentar Novamente?</CardTitle>
                            </CardHeader>
                            <CardContent>
                                <p className="text-sm text-muted-foreground mb-4">
                                    Você pode voltar e escolher o plano que melhor se adequa às suas necessidades.
                                </p>
                                <Button asChild variant="outline" className="w-full">
                                    <Link to="/diagnostico-completo" className="flex items-center gap-2">
                                        <ArrowLeft className="h-4 w-4" />
                                        Ver Planos
                                    </Link>
                                </Button>
                            </CardContent>
                        </Card>
                    </div>

                    <div className="flex flex-col sm:flex-row gap-3 justify-center pt-4">
                        <Button asChild size="lg">
                            <Link to="/diagnostico-completo">Escolher Plano</Link>
                        </Button>
                        <Button asChild variant="outline" size="lg">
                            <Link to="/">Voltar para Home</Link>
                        </Button>
                    </div>

                    <p className="text-xs text-center text-muted-foreground">
                        Dúvidas? Entre em contato: <a href="mailto:contato@coddar.com.br" className="text-primary hover:underline">contato@coddar.com.br</a>
                    </p>
                </CardContent>
            </Card>
        </div>
    );
}
